var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.5 21H22.5V22.5H1.5V21Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.25 8.25C20.4489 8.25 20.6397 8.17098 20.7803 8.03033C20.921 7.88968 21 7.69891 21 7.5V5.25C20.9999 5.09586 20.9524 4.94549 20.8638 4.81935C20.7752 4.6932 20.65 4.59741 20.505 4.545L12.255 1.545C12.0902 1.48543 11.9098 1.48543 11.745 1.545L3.495 4.545C3.35005 4.59741 3.22476 4.6932 3.13619 4.81935C3.04762 4.94549 3.00007 5.09586 3 5.25V7.5C3 7.69891 3.07902 7.88968 3.21967 8.03033C3.36032 8.17098 3.55109 8.25 3.75 8.25H4.5V18H3V19.5H21V18H19.5V8.25H20.25ZM12 3.045L4.5 5.775V6.75H19.5V5.775L12 3.045ZM10.5 18H13.5V8.25H10.5V18ZM9 8.25H6V18H9V8.25ZM15 18H18V8.25H15V18Z",
  fill: "currentColor"
});

var SvgBankIcon = function SvgBankIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBankIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BankIcon.7eea01f1.svg";
export { ForwardRef as ReactComponent };